import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=4ba5574f&scoped=true"
import script from "./sign.vue?vue&type=script&lang=js"
export * from "./sign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba5574f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba5574f')) {
      api.createRecord('4ba5574f', component.options)
    } else {
      api.reload('4ba5574f', component.options)
    }
    module.hot.accept("./sign.vue?vue&type=template&id=4ba5574f&scoped=true", function () {
      api.rerender('4ba5574f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sign/sign.vue"
export default component.exports